import { render, staticRenderFns } from "./getPoints.vue?vue&type=template&id=4363cfbd&scoped=true"
import script from "./getPoints.vue?vue&type=script&lang=js"
export * from "./getPoints.vue?vue&type=script&lang=js"
import style0 from "./getPoints.vue?vue&type=style&index=0&id=4363cfbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363cfbd",
  null
  
)

export default component.exports